import type { CriterionComparisonValueMode } from "../../../criterionConfig";
import CriterionComparisonValueField from "../Inputs/CriterionComparisonValueField";

import type { SmartColumn } from "@/queries/smart-tables/types";

interface ContainsFieldsProps {
  mode: CriterionComparisonValueMode;
  staticValue: string;
  columnId: string;
  columns: SmartColumn[];
  onModeChange: (mode: CriterionComparisonValueMode) => void;
  onStaticValueChange: (value: string) => void;
  onColumnChange: (columnId: string) => void;
}

export const ContainsFields = ({
  mode,
  staticValue,
  columnId,
  columns,
  onModeChange,
  onStaticValueChange,
  onColumnChange,
}: ContainsFieldsProps) => (
  <CriterionComparisonValueField
    mode={mode}
    staticValue={staticValue}
    columnId={columnId}
    columns={columns}
    onModeChange={onModeChange}
    onStaticValueChange={onStaticValueChange}
    onColumnChange={onColumnChange}
  />
);
